export default "__VITE_ASSET__pvHUnsWq__"